<template>
  <ul class="master-wrapper">
    <li v-for="(item, index) in courseList" :key="item.stagePackId" class="course-box-class" :class="{bkOne: index%3 === 0 ,bkTwo: index%3 === 1, bkThree: index%3 === 2}" @click="handleChoose(item, index)">
      <span class="course-name">{{item.courseStageName}}</span>
    </li>
  </ul>
</template>

<script>
import cookie from 'js-cookie'
import { getStudentCourseInfo } from '@/api/account'
export default {
  data () {
    return {
      urrStudentId: '',
      courseList: []
    }
  },
  created () {
    this.currStudentId = this.$route.query.studentId || cookie.get('mbstudentid')
    getStudentCourseInfo(this.currStudentId).then(res => {
      if (res.data) {
        this.courseList = res.data || []
      }
    })
  },
  methods: {
    handleChoose (item, index) {
      console.log('选择课程：', item, index)
      this.$router.push({
        name: 'accountMasterDetail',
        params: {
          courseStageId: item.courseStageId
        }
      })
      console.log('data:', item.courseStageId)
    }
  }
}
</script>

<style lang="scss" scoped>
.master-wrapper {
  width: 100%;
  min-height: 100vh;
  background: linear-gradient(0deg,rgba(27,127,245,1) 0%,rgba(57,155,245,1) 100%);
  padding: 56px 0 42px;
  .course-box-class{
    display: block;
    width: 680px;
    height: 218px;
    margin: 0 auto 42px;
    background: #fff;
    .course-name{
      width: 460px;
      padding: 40px 0 0 31px;
      font-size:38px;
      font-weight:bold;
      text-align: left;
      color:rgba(134,132,132,1);
      line-height:50px;
      display: -webkit-box;
      overflow: hidden;
      text-overflow: ellipsis;
      -webkit-box-orient: vertical;
      -webkit-line-clamp: 2;
    }
  }
  .bkOne, .bkTwo,  .bkThree{
    background-repeat:no-repeat;
    background-size:100% 100%;
    border-radius: 16px;
  }
  .bkOne {
    background-image: url('~@/assets/img/master/course-bk-cat.png');
  }
  .bkTwo {
    background-image: url('~@/assets/img/master/course-bk-frog.png');
  }
  .bkThree {
    background-image: url('~@/assets/img/master/course-bk-pig.png');
  }

}
</style>
